import React from "react";
import style from "css/lecture.module.css";
import { Link } from "react-router-dom";
import Questions from "components/app/questions";
import { useMediaQuery } from "react-responsive";
import SEOMeta from "components/app/SEOMeta";

function Main() {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  const composeList = [
    {
      id: 1,
      title: "하이브리드 스마트 강의실",
      link: "smart-space/room/classRoom",
      img: "img/smartspace/lecturemaincardimg1.png",
      img_m: "img/smartspace/lecturemaincardimg1_m.png",
    },
    {
      id: 2,
      title: "하이브리드 그룹 강의실",
      link: "smart-space/room/group",
      img: "img/smartspace/lecturemaincardimg2.png",
      img_m: "img/smartspace/lecturemaincardimg2_m.png",
    },
    {
      id: 3,
      title: "하이브리드 스마트 실습실",
      link: "smart-space/room/lab",
      img: "img/smartspace/lecturemaincardimg3.png",
      img_m: "img/smartspace/lecturemaincardimg3_m.png",
    },
    {
      id: 4,
      title: "하이브리드 스마트 연구실 / 교수실",
      link: "smart-space/room/laboratory",
      img: "img/smartspace/lecturemaincardimg4.png",
      img_m: "img/smartspace/lecturemaincardimg4_m.png",
    },
    {
      id: 5,
      title: "스마트 강의 컨트롤 시스템",
      link: "smart-solution/deviceOne",
      img: "img/smartspace/lecturemaincardimg5.png",
      img_m: "img/smartspace/lecturemaincardimg5_m.png",
    },
  ];

  return (
    <>
      <SEOMeta
        title="스마트 강의실/교실, 리브테크놀로지"
        description="리브테크놀로지 riv Technolohy - 스마트 강의실/교실"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 스마트 회의실, 화상회의, 스마트 강의실/교실, 
        하이브리드 스마트 강의실, 하이브리드 그룹 강의실,
        하이브리드 스마트 실습실, 하이브리드 연구실/교수실"
      />
      <div className={style.wrapper}>
        <div className={style.mainImg}>
          <div className={style.mainTxt}>
            <p>미래지향적 최첨단 강의실 & 교실</p>
            <p>리브테크놀로지</p>
            <p>Hybrid Smart{"\n"} Classroom</p>
          </div>

          <img
            alt=""
            src={
              !isMobile && !isTablet
                ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/lecturemain1.png`
                : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/lecturemain1_m.png`
            }
          />
        </div>
        <div className={style.mainEx}>
          <div className={style.mainExTxt}>
            <p>하이브리드 스마트 강의실 / 교실</p>
            <p>Hybrid Smart{"\n"} Classroom</p>
            <p>
              하이브리드 러닝(Learning)에 최적화된{"\n"} 스마트 강의실 입니다.
            </p>
          </div>
          <img
            alt=""
            src={
              !isMobile && !isTablet
                ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/lecturemain2.png`
                : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/lecturemain2_m.png`
            }
          />
          <div className={style.mainExCardList}>
            <div>
              <p className={style.exListNum}>1</p>
              <p className={style.exListTxt}>하이브리드 스마트 강의실</p>
            </div>
            <div>
              <p className={style.exListNum}>2</p>
              <p className={style.exListTxt}>하이브리드 그룹 강의실</p>
            </div>
            <div>
              <p className={style.exListNum}>3</p>
              <p className={style.exListTxt}>하이브리드 스마트 실습실</p>
            </div>
            <div>
              <p className={style.exListNum}>4</p>
              <p className={style.exListTxt}>
                하이브리드 스마트 연구실 / 교수님 개인용
              </p>
            </div>
            {/* <div>
            <p className={style.exListNum}>5</p>
            <p className={style.exListTxt}>스마트 강의 컨트롤 시스템</p>
          </div> */}
          </div>
        </div>
        <div className={style.mainComposeWrap}>
          <div className={style.mainCompose}>
            <div className={style.mainComposeTxt}>
              <p>구성환경</p>
              <p>
                <font>Hybrid Learning</font>을 위한{"\n"} 공간 구성
              </p>
              <p>
                하이브리드 러닝에 최적화된 스마트 강의실/교실은{"\n"}{" "}
                온·오프라인 학습을 원활하게 연결하여, 어디서든 몰입감 있는 학습
                경험을 제공합니다.
              </p>
            </div>
            <div className={style.composeList}>
              {composeList.map((item) => (
                <div
                  className={
                    item.id === 4
                      ? style.composeCard + " cursor " + style.composeCard4th
                      : style.composeCard + " cursor"
                  }
                >
                  {item.id === 5 ? (
                    <span className={style.composeLabel}>Platform</span>
                  ) : null}
                  <Link to={`${process.env.REACT_APP_CLIENT_URL + item.link}`}>
                    <img
                      className={style.composeCardImg}
                      alt=""
                      src={
                        !isMobile && !isTablet
                          ? `${process.env.REACT_APP_CLIENT_URL + item.img}`
                          : `${process.env.REACT_APP_CLIENT_URL + item.img_m}`
                      }
                    />
                    <div>
                      <p>{item.title}</p>
                      <p>
                        <font>More</font>{" "}
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/arrowRight.png"
                          }
                        />
                      </p>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div
          className={style.mainImg2}
          style={{
            backgroundImage:
              "url('" +
              `${process.env.REACT_APP_CLIENT_URL}` +
              "img/smartspace/workspacemain2.png')",
          }}
        >
          <div className={style.main2Txt}>
            <div>
              <label />
              {!isMobile && !isTablet ? (
                <p>
                  <font>온/오프라인 동시 수업</font>이 가능하도록 운영되는
                  수업방식으로 <br /> 공간적 한계를 뛰어넘는 최첨단 시스템을
                  활용하여 <br />
                  <font>
                    교육 실재감을 높이고 수업에 몰입 할 수있는 구축환경
                  </font>
                  입니다.
                </p>
              ) : (
                <p>
                  <font>온/오프라인 동시 수업</font>이 가능하도록
                  <br />
                  운영되는 수업방식으로
                  <br /> 공간적 한계를 뛰어넘는 최첨단 시스템을
                  <br />
                  활용하여{" "}
                  <font>
                    교육 실재감을 높이고
                    <br /> 수업에 몰입 할 수있는 구축환경
                  </font>
                  입니다.
                </p>
              )}

              <label />
            </div>
            <img
              alt=""
              src={
                !isMobile && !isTablet
                  ? `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/lecturemain3.png"
                  : `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/lecturemain3_m.png"
              }
            />
            <div>
              <p>
                <font>하이브리드 러닝</font>에 최적화된{"\n"}{" "}
                <font>스마트 강의실</font> 입니다.
              </p>
            </div>
          </div>
        </div>
        {/* <div className={style.clients}>
          <div className={style.clientsHeader}>
            <p>Clients and Partners</p>
            <p>
              2012년부터 리브테크놀로지와 많은 기업/기관/학교들이 함께했습니다.
            </p>
          </div>
          <div className={style.clientsInfo}>
            <div>
              <p>
                <font>89</font>
                <font>+</font>
              </p>
              <p>사용 기관</p>
            </div>
            <div />
            <div>
              <p>
                <font>568,676</font>
                <font>+</font>
              </p>
              <p>연 사용 인원</p>
            </div>
          </div>
          <div className={style.clientsMore}>
            <p>More view Clients</p>
            <img
              alt=""
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                "img/smartspace/arrowRight.png"
              }
            />
          </div>
        </div> */}
        <Questions />
      </div>
    </>
  );
}

export default Main;
